import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Tab, Table } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/investment.js';
import axios from 'axios';

function CommunityPortal() {
    useEffect(() => {
        document.title = 'Investment | REAL FM';
        const courseButton = document.querySelectorAll(".course-button");
        courseButton.forEach(button => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                const content = button.nextElementSibling;

                if (button.classList.contains("active")) {
                    content.className = "course-content show";
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.className = "course-content";
                    content.style.maxHeight = "0";
                }
            });
        });
    });

    
    const [investmentInfo, setInvestmentInfo] = useState([]);
    const [investmentAdditionalDisburseInfo, setInvestmentAdditionalDisburseInfo] = useState([]);

    useEffect(() => {
        const getInvestmentInfo = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/investment-services/find-all`).then(res => {
                setInvestmentInfo(res.data)
            }).catch(err => console.error(err))
        }

        const getDisburseInfo = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/investment/disburse/find-all`).then(res => {
                setInvestmentAdditionalDisburseInfo(res.data)
            }).catch(err => console.error(err))
        }
        
        getInvestmentInfo();
        getDisburseInfo();
    },[])


    return (
        <div className="main-wrapper course-details-page" >

            {/* Header 2 */}
            <HeaderTwo />

            {/* Breadcroumb */}
            <BreadcrumbBox title="Investment" />

            <Styles>
                {/* Course Details */}
                <section className="course-details-area">
                    <Container className="card custom-card">
                        <Row>
                                <Col lg="12" md="12" sm="12">
                                    <div className="course-details-top">
                                    
                                        <div className="course-tab-list">
                                            <Tab.Container defaultActiveKey="overview">
                                                
                                                {
                                                    investmentInfo && investmentInfo.length > 0 ? investmentInfo.map((info, i) => (
                                                        <Tab.Content key={i}>
                                                            <Tab.Pane eventKey="overview" className="overview-tab">
                                                            
                                                                {
                                                                    <div className="course-feature ">
                                                                    <Row>
                                                                    
                                                                        <Col sm="12">
                                                                            {/* <p>Every building is special; accordingly, we provide a fully customised proposal which outlines our customer centred, and cost effective service. 
                                                                            <strong><i>Call Wendy Kenny, Business Development Manager on 9930 0730 or 
                                                                            email <a className="invest-mail" href="mailto:bdm@realfm.net.au?subject=Email From Website&body=Dear Concerned, %0A <Write your details here>" target="_blank" rel="noopener noreferrer">bdm@realfm.net.au</a></i></strong> for a confidential discussion about your building.</p><br></br>
                                                                            
                                                                            <p>However, as an indication, a medium size building proposal (80 Lots) may include:</p> */}
                                                                            <p dangerouslySetInnerHTML={{ __html: info.investServiceDesc}}></p>
                                                                            
                                                                        </Col>                                                        
                                                                    </Row>
                                                                    
                                                                </div>
                                                                }
                                                                
                                                                
                                                            </Tab.Pane>
                                                            
                                                        </Tab.Content>
                                                    )): "No content found"
                                                }
                                                
                                            </Tab.Container>
                                        </div>
                                    </div>
                                </Col>                            
                        </Row>

                        <div className="investment-table">
                        <Row>
                            <Col lg="12" md="12" sm="12">
                            <Table  bordered  responsive="sm" className="inv-firstTable">
                                <thead>
                                    <tr>
                                    <th>SERVICE DESCRIPTION</th>
                                    <th>MONTHLY FEE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    investmentInfo && investmentInfo.length > 0 ? investmentInfo.map((info, i) => (
                                        <tr key={i}>
                                   
                                            <td>
                                                {info.invServiceTitle}
                                                <ul className="list-unstyled list-inline">
                                                    {
                                                        info.invServiceSubTitle && info.invServiceSubTitle.length > 0 ? info.invServiceSubTitle.map((st, j) => (
                                                            <li className="list-inline-item" key={j + 1}>
                                                            <i className="fa fa-check"></i> {st}
                                                            </li>
                                                         )): "No subtitles found"
                                                    }
                                                   
                                                    {/* <li className="list-inline-item">
                                                    <i className="fa fa-check"></i>Includes attendance to strata committee and general meetings to 8pm.</li> */}
                                                </ul>
                                            </td>
                                            <td><strong>Fixed Fee</strong></td>

                                        </tr>
                                  
                                    )) : "No contents"
                                }
                                   
                                   
                                </tbody>
                            </Table>
                            </Col>
                        </Row>
                        </div>

                            <div className="additional-disburse">
                            <h5>ADDITIONAL DISBURSEMENT SCHEDULE</h5>

                                <Row>
                                    <Col lg="12" md="12" sm="12">
                                    <Table  bordered size='lg' responsive="sm" className="inv-secondTable">
                                        <thead>
                                            <tr>
                                            <th>SERVICE DESCRIPTION</th>
                                            <th >INCLUDED</th>
                                            <th>CLIENT’S EXPENSE(optional)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            investmentAdditionalDisburseInfo && investmentAdditionalDisburseInfo.length > 0 ? investmentAdditionalDisburseInfo.map((val, i) => (
                                                <tr key={i}>
                                        
                                                    <td>
                                                        {val.invServiceTitle}
                                                        <p>{val.invServiceSubTitle}</p>
                                                    </td>
                                                    <td>
                                                        <ul className="list-unstyled list-inline">
                                                            <li className="list-inline-item">
                                                        {val.hasDisburseFeature == true && <i className="fa fa-check"></i>}
                                                            </li>
                                                        
                                                        </ul>
                                                    </td>
                                                    <td>
                                                        <ul className="list-unstyled list-inline">
                                                            <li className="list-inline-item">
                                                        {val.hasClientExpense == true && <i className="fa fa-check"></i>}
                                                            </li>
                                                        
                                                        </ul>
                                                    </td>

                                                </tr>
                                            )): "No features" 
                                        }
                                        
                                        
                                        </tbody>
                                    </Table>
                                    </Col>
                                </Row>
                        </div>
                            

                       
                        
                </Container>
            </section>
        </Styles>

            {/* Footer 2 */}
            <FooterTwo />

        </div>
    )
}

export default CommunityPortal